export const genericReducer = ({
  setAction,
  resetAction,
  actionProperty,
  defaultState = null
}) => {
  return (state = defaultState, action) => {
    if (setAction && action.type === setAction) {
      return action[actionProperty];
    }

    if (resetAction && action.type === resetAction) {
      return defaultState;
    }

    return state;
  };
};
